import draftJs from "draft-js";
import handlebars from "handlebars";
import { draftStateToHtml } from "../functions.js";
const { convertFromRaw } = draftJs;
// Checks whether a user-editable template body is syntactically valid Handlebars,
// so a body that would abort the whole render (e.g. an unreplaced
// `{{…<prop_key>…}}` example, whose `<`/`>` are illegal in a path) is never
// persisted. Uses `Handlebars.parse` — exactly the parse step that the renderer's
// lazy `compile` defers to first execution — so no context or rendering is needed
// and valid templates (including ones using helpers) are never falsely rejected.
//
// Bodies stored as Draft.js raw content state (quote / document texts) are first
// converted to the text the renderer compiles; plain HTML / string bodies (email
// templates) are parsed as-is. Never throws — the outcome is the return value.
export function validateTemplate(body) {
    if (!body)
        return { valid: true };
    const source = toTemplateSource(body);
    try {
        handlebars.parse(source);
        return { valid: true };
    }
    catch (e) {
        return { valid: false, error: e instanceof Error ? e.message : String(e) };
    }
}
// Mirrors the renderer: a Draft.js raw content state JSON is rendered to text
// before parsing; anything else is parsed directly.
function toTemplateSource(body) {
    try {
        const parsed = JSON.parse(body);
        if (parsed &&
            typeof parsed === "object" &&
            Array.isArray(parsed.blocks)) {
            return draftStateToHtml(convertFromRaw(parsed));
        }
    }
    catch {
        // not JSON — treat as a plain HTML / string body
    }
    return body;
}
//# sourceMappingURL=validate.js.map